/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompaniesExportXlsxRequest } from '../models/CompaniesExportXlsxRequest';
import type { DownstreamPotentialAggregateRequest } from '../models/DownstreamPotentialAggregateRequest';
import type { DownstreamPotentialAggregateResponse } from '../models/DownstreamPotentialAggregateResponse';
import type { DownstreamPotentialDetailRequest } from '../models/DownstreamPotentialDetailRequest';
import type { DownstreamPotentialDetailResponse } from '../models/DownstreamPotentialDetailResponse';
import type { DownstreamPotentialRequest } from '../models/DownstreamPotentialRequest';
import type { DownstreamPotentialResponse } from '../models/DownstreamPotentialResponse';
import type { StableIdsRequest } from '../models/StableIdsRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CompaniesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Export Companies Xlsx
     * Export companies for the currently displayed /companies graph (root + upstream layers),
     * as an Excel file with one sheet per layer plus a first "Legend" sheet.
     *
     * - Rows: one per (element × company)
     * - Country behavior: only the selected country (value-chain gating enforced)
     * - Financials: all fields from selected meta_id for selected year; blank when missing
     * @param requestBody
     * @returns binary XLSX file
     * @throws ApiError
     */
    public exportCompaniesXlsxApiV1CompaniesExportXlsxPost(
        requestBody: CompaniesExportXlsxRequest,
    ): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/export-xlsx',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Companies Xlsx
     * Export companies for the currently displayed /companies graph (root + upstream layers),
     * as an Excel file with one sheet per layer plus a first "Legend" sheet.
     *
     * - Rows: one per (element × company)
     * - Country behavior: only the selected country (value-chain gating enforced)
     * - Financials: all fields from selected meta_id for selected year; blank when missing
     * @param requestBody
     * @returns binary XLSX file
     * @throws ApiError
     */
    public exportCompaniesXlsxApiV1CompaniesExportXlsxPost1(
        requestBody: CompaniesExportXlsxRequest,
    ): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/export-xlsx',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Aggregate Downstream Potential
     * Compute downstream potential summary for a value chain using a single metric.
     * Returns aggregated, ranked target elements with context.
     * @param requestBody
     * @returns DownstreamPotentialAggregateResponse Successful Response
     * @throws ApiError
     */
    public aggregateDownstreamPotentialApiV1CompaniesDownstreamPotentialAggregatePost(
        requestBody: DownstreamPotentialAggregateRequest,
    ): CancelablePromise<DownstreamPotentialAggregateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/downstream-potential/aggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Aggregate Downstream Potential
     * Compute downstream potential summary for a value chain using a single metric.
     * Returns aggregated, ranked target elements with context.
     * @param requestBody
     * @returns DownstreamPotentialAggregateResponse Successful Response
     * @throws ApiError
     */
    public aggregateDownstreamPotentialApiV1CompaniesDownstreamPotentialAggregatePost1(
        requestBody: DownstreamPotentialAggregateRequest,
    ): CancelablePromise<DownstreamPotentialAggregateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/downstream-potential/aggregate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Downstream Potential Detail
     * @param requestBody
     * @returns DownstreamPotentialDetailResponse Successful Response
     * @throws ApiError
     */
    public downstreamPotentialDetailApiV1CompaniesDownstreamPotentialDetailPost(
        requestBody: DownstreamPotentialDetailRequest,
    ): CancelablePromise<DownstreamPotentialDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/downstream-potential/detail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Downstream Potential Detail
     * @param requestBody
     * @returns DownstreamPotentialDetailResponse Successful Response
     * @throws ApiError
     */
    public downstreamPotentialDetailApiV1CompaniesDownstreamPotentialDetailPost1(
        requestBody: DownstreamPotentialDetailRequest,
    ): CancelablePromise<DownstreamPotentialDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/downstream-potential/detail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Companies By Stable Ids
     * @param requestBody
     * @param country Filter addresses by country (required when value_chain_name is provided)
     * @param valueChainName When set, only return addresses for this explicit country if (value_chain_name, country) exists in availability table
     * @returns any Successful Response
     * @throws ApiError
     */
    public getCompaniesByStableIdsApiV1CompaniesByStableIdsPost(
        requestBody: StableIdsRequest,
        country?: (string | null),
        valueChainName?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/by-stable-ids',
            query: {
                'country': country,
                'value_chain_name': valueChainName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Companies By Stable Ids
     * @param requestBody
     * @param country Filter addresses by country (required when value_chain_name is provided)
     * @param valueChainName When set, only return addresses for this explicit country if (value_chain_name, country) exists in availability table
     * @returns any Successful Response
     * @throws ApiError
     */
    public getCompaniesByStableIdsApiV1CompaniesByStableIdsPost1(
        requestBody: StableIdsRequest,
        country?: (string | null),
        valueChainName?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/by-stable-ids',
            query: {
                'country': country,
                'value_chain_name': valueChainName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Companies By Stable Ids With Financials
     * Return companies by stable_ids enriched with accessible financial data per company_domain.
     * - Address country selection respects the same country-permission gating as /by-stable-ids
     * - Financial data is filtered by the current user's (country, source) permissions
     * @param requestBody
     * @param country Filter addresses by country (required when value_chain_name is provided)
     * @param valueChainName When set, only return addresses for this explicit country if (value_chain_name, country) exists in availability table
     * @returns any Successful Response
     * @throws ApiError
     */
    public getCompaniesByStableIdsWithFinancialsApiV1CompaniesByStableIdsWithFinancialsPost(
        requestBody: StableIdsRequest,
        country?: (string | null),
        valueChainName?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/by-stable-ids-with-financials',
            query: {
                'country': country,
                'value_chain_name': valueChainName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Companies By Stable Ids With Financials
     * Return companies by stable_ids enriched with accessible financial data per company_domain.
     * - Address country selection respects the same country-permission gating as /by-stable-ids
     * - Financial data is filtered by the current user's (country, source) permissions
     * @param requestBody
     * @param country Filter addresses by country (required when value_chain_name is provided)
     * @param valueChainName When set, only return addresses for this explicit country if (value_chain_name, country) exists in availability table
     * @returns any Successful Response
     * @throws ApiError
     */
    public getCompaniesByStableIdsWithFinancialsApiV1CompaniesByStableIdsWithFinancialsPost1(
        requestBody: StableIdsRequest,
        country?: (string | null),
        valueChainName?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/by-stable-ids-with-financials',
            query: {
                'country': country,
                'value_chain_name': valueChainName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Element Company Financials
     * Retrieve companies and financial rows for a set of element stable IDs, filtered by country,
     * metadata id, and optional years. Uses deterministic dedupe rules to mirror downstream analysis.
     * @param requestBody
     * @returns DownstreamPotentialResponse Successful Response
     * @throws ApiError
     */
    public getElementCompanyFinancialsApiV1CompaniesElementCompanyFinancialsPost(
        requestBody: DownstreamPotentialRequest,
    ): CancelablePromise<DownstreamPotentialResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/element-company-financials',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Element Company Financials
     * Retrieve companies and financial rows for a set of element stable IDs, filtered by country,
     * metadata id, and optional years. Uses deterministic dedupe rules to mirror downstream analysis.
     * @param requestBody
     * @returns DownstreamPotentialResponse Successful Response
     * @throws ApiError
     */
    public getElementCompanyFinancialsApiV1CompaniesElementCompanyFinancialsPost1(
        requestBody: DownstreamPotentialRequest,
    ): CancelablePromise<DownstreamPotentialResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/element-company-financials',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Companies Countries
     * Return distinct country names present in company addresses, filtered by permissions.
     *
     * - Admin: all countries (optionally scoped by stable_ids)
     * - Auth non-admin: only countries granted via UserDataPermissions(data_type='country')
     * - Unauth: only countries granted to the public pseudo-user
     * @param stableIds Optional: filter to countries present for these stable_ids
     * @param valueChainName When set, only return countries available for this value chain
     * @returns any Successful Response
     * @throws ApiError
     */
    public listCompaniesCountriesApiV1CompaniesCountriesGet(
        stableIds?: (Array<string> | null),
        valueChainName?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/countries',
            query: {
                'stable_ids': stableIds,
                'value_chain_name': valueChainName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Companies Countries
     * Return distinct country names present in company addresses, filtered by permissions.
     *
     * - Admin: all countries (optionally scoped by stable_ids)
     * - Auth non-admin: only countries granted via UserDataPermissions(data_type='country')
     * - Unauth: only countries granted to the public pseudo-user
     * @param stableIds Optional: filter to countries present for these stable_ids
     * @param valueChainName When set, only return countries available for this value chain
     * @returns any Successful Response
     * @throws ApiError
     */
    public listCompaniesCountriesApiV1CompaniesCountriesGet1(
        stableIds?: (Array<string> | null),
        valueChainName?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/countries',
            query: {
                'stable_ids': stableIds,
                'value_chain_name': valueChainName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Companies Countries Post
     * POST variant to avoid very long query strings in staging (WAF / proxy limits).
     * Accepts a JSON body with stable_ids.
     * @param requestBody
     * @param valueChainName When set, only return countries available for this value chain
     * @returns any Successful Response
     * @throws ApiError
     */
    public listCompaniesCountriesPostApiV1CompaniesCountriesByStableIdsPost(
        requestBody: StableIdsRequest,
        valueChainName?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/countries/by-stable-ids',
            query: {
                'value_chain_name': valueChainName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Companies Countries Post
     * POST variant to avoid very long query strings in staging (WAF / proxy limits).
     * Accepts a JSON body with stable_ids.
     * @param requestBody
     * @param valueChainName When set, only return countries available for this value chain
     * @returns any Successful Response
     * @throws ApiError
     */
    public listCompaniesCountriesPostApiV1CompaniesCountriesByStableIdsPost1(
        requestBody: StableIdsRequest,
        valueChainName?: (string | null),
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/countries/by-stable-ids',
            query: {
                'value_chain_name': valueChainName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Value Chain Meta Info
     * Get metadata (info and shortcomings) for a specific value chain.
     * This endpoint is public - no authentication required.
     * @param valueChainName
     * @returns any Successful Response
     * @throws ApiError
     */
    public getValueChainMetaInfoApiV1CompaniesValueChainMetaValueChainNameGet(
        valueChainName: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/value-chain-meta/{value_chain_name}',
            path: {
                'value_chain_name': valueChainName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Value Chain Meta Info
     * Get metadata (info and shortcomings) for a specific value chain.
     * This endpoint is public - no authentication required.
     * @param valueChainName
     * @returns any Successful Response
     * @throws ApiError
     */
    public getValueChainMetaInfoApiV1CompaniesValueChainMetaValueChainNameGet1(
        valueChainName: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/value-chain-meta/{value_chain_name}',
            path: {
                'value_chain_name': valueChainName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Value Chain Meta Info
     * List all value chain metadata entries.
     * This endpoint is public - no authentication required.
     * @returns any Successful Response
     * @throws ApiError
     */
    public listValueChainMetaInfoApiV1CompaniesValueChainMetaGet(): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/value-chain-meta',
        });
    }
    /**
     * List Value Chain Meta Info
     * List all value chain metadata entries.
     * This endpoint is public - no authentication required.
     * @returns any Successful Response
     * @throws ApiError
     */
    public listValueChainMetaInfoApiV1CompaniesValueChainMetaGet1(): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/value-chain-meta',
        });
    }
}
